<template>
    <div class="menu-selection">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <img src="../assets/img/ecdc-logo.svg" alt="ecdc-logo" class="img-fluid logo" />
                </div>
            </div>

            <div class="row align-items-center mb-40">
                <div class="col-3">
                    <div class="btn-back" @click="$router.go(-1);">
                        <font-awesome-icon :icon="['fas', 'angle-left']" />
                        Back
                    </div>
                </div>

                <div class=col-6>
                    <div class="title">
                        Choose Your Favourite Menu
                    </div>
                </div>

                <div class="col-3">
                    <div class="amount-selected">
                        4 / 6 
                        <button class="btn btn-ecdc">Done</button>
                    </div>
                </div>
            </div>

            <div class="row row-cols-4">
                <div class="col mb-4">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <app-icon-product></app-icon-product>
                        </div>

                        WSA

                        <div class="desc">
                            Lorem ipsum dolor sit amet, consetetur 
                        </div>
                    </div>
                </div>
                
                <div class="col mb-4">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <font-awesome-icon :icon="['far', 'user']" />
                        </div>

                        WSA

                        <div class="desc">
                            Lorem ipsum dolor sit amet
                        </div>
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <font-awesome-icon :icon="['far', 'user']" />
                        </div>

                        WSA

                        <div class="desc">
                            Lorem ipsum dolor sit amet, consetetur 
                        </div>

                        <div class="icon-checked">
                            <font-awesome-icon :icon="['fas', 'check']" />
                        </div>
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <font-awesome-icon :icon="['far', 'user']" />
                        </div>

                        WSA

                        <div class="desc">
                            Lorem ipsum dolor sit amet, consetetur
                        </div>
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <font-awesome-icon :icon="['far', 'user']" />
                        </div>

                        WSA

                        <div class="desc">
                            Lorem ipsum dolor sit amet, consetetur
                        </div>
                    </div>
                </div>

                <div class="col mb-4">
                    <div class="card selection-card h-100">
                        <div class="icon">
                            <font-awesome-icon :icon="['far', 'user']" />
                        </div>

                        WSA

                        <div class="desc">
                            Lorem ipsum dolor sit amet, consetetur
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import IconProduct from '../svg/Product.vue'

export default {
    components: {
        appIconProduct: IconProduct,

    }
}
</script>

<style scoped>
.menu-selection .logo {
    margin-bottom: 60px;
}

.menu-selection .btn-ecdc {
    margin-left: 20px;
}

.menu-selection .card {
    border: 3px solid transparent;
}

.menu-selection .card .icon-checked {
    position: absolute;
    font-size: 10px;
    padding: 3px 5px 1px 5px;
    background-color: #FDCD08;
    border-radius: 50px;
    top: 10px;
    right: 10px;
}

.menu-selection .card.active {
    border-color: #FDCD08;
}
</style>